import { render, staticRenderFns } from "./PriceSummaryPayGo.vue?vue&type=template&id=5cf5a8cc&scoped=true"
import script from "./PriceSummaryPayGo.vue?vue&type=script&lang=js"
export * from "./PriceSummaryPayGo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf5a8cc",
  null
  
)

export default component.exports